enum LoggingLevel {
  TRACE,
  DEBUG,
  INFO,
  WARN,
  ERROR,
}

export default LoggingLevel;
